import { Link, router } from "@inertiajs/react"
import { usePage } from "@inertiajs/react"
import Avatar from "./Avatar"

export default function Layout({ children }) {
  const { current_user, flash } = usePage().props

  function signOut(e) {
    e.preventDefault()
    router.delete("/signout")
  }

  return (
    <div className="min-h-screen bg-stone-950 text-stone-100">
      <header className="border-b border-stone-800/60 px-4 py-3">
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <Link href="/" className="font-serif text-lg text-cream tracking-tight hover:text-white transition-colors">
            octave
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            {current_user ? (
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 text-stone-400">
                  <Avatar user={current_user} size="sm" />
                  <span className="max-w-28 truncate">@{current_user.username}</span>
                </div>
                <button onClick={signOut} className="text-stone-500 hover:text-stone-300 transition-colors">
                  sign out
                </button>
              </div>
            ) : (
              <a
                href="mailto:hrishimittal@gmail.com?subject=Octave%20waitlist"
                className="text-stone-500 hover:text-stone-300 transition-colors"
              >
                request access
              </a>
            )}
          </nav>
        </div>
      </header>

      {flash?.notice && (
        <div className="px-4 pt-4">
          <div className="max-w-2xl mx-auto">
            <div className="bg-stone-800 text-stone-200 text-sm px-4 py-2 rounded-lg">
              {flash.notice}
            </div>
          </div>
        </div>
      )}

      {flash?.alert && (
        <div className="px-4 pt-4">
          <div className="max-w-2xl mx-auto">
            <div className="bg-red-950/50 text-red-300 text-sm px-4 py-2 rounded-lg border border-red-900/50">
              {flash.alert}
            </div>
          </div>
        </div>
      )}

      <main className="px-4 py-6">
        <div className="max-w-2xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  )
}
